// extracted by mini-css-extract-plugin
module.exports = {"weepeople":"style_weepeople__2rvKE","wee":"style_wee__3DSaw","label":"style_label__122JX"};